<template>
    <div>
      <div class="action-buttons">
          <div class="left-button">
            <div class="form-group" style="flex: 1;">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <option :value="null">Selectează</option>
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
            <div class="search-button-reports">
              <button
                  :title="$t('reports.search')"
                  class="btn add mar-rt-10"
                  @click="onSearch"
              >
                  <i class="ti-search"></i>
                  <span>{{ $t('general.search') }}</span>
              </button>
            </div>
          </div>
          <div class="right-buttons">
            <button class="btn add mar-rt-10" type="success" @click="addBonTransfer()">
                <img src="/static/img/icons/add.png">
                {{ $t('gestiune.addNoteTransfer') }}
            </button>
         </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="data-table">
              <el-table :data="tableData" :empty-text="$t('gestiune.noData')">
                <el-table-column label="Nr." prop="documentNumber" width="100">
                  <template slot-scope="scope">
                    {{ scope.row.documentNumber }}
                  </template>
                </el-table-column>

                <el-table-column label="Serie" prop="series" width="100">
                  <template slot-scope="scope">
                    {{ scope.row.series }}
                  </template>
                </el-table-column>

                <el-table-column label="Din Gestiunea" prop="gestiune_from">
                  <template slot-scope="scope">
                    {{ getGestiuneNameById(scope.row.gestiune_from) }}
                  </template>
                </el-table-column>

                <el-table-column label="La Gestiunea" prop="gestiune_to">
                  <template slot-scope="scope">
                    {{ getGestiuneNameById(scope.row.gestiune_to) }}
                  </template>
                </el-table-column>

                <!-- <el-table-column label="Total" prop="total" width="200">
                  <template slot-scope="scope">
                    {{ scope.row.total }}
                  </template>
                </el-table-column> -->

                <el-table-column :label="$t('general.actions')" width="100">
                  <template slot-scope="scope">
                    <el-dropdown trigger="click" placement="bottom-end">
                      <!-- Trigger: sageata jos cu border violet -->
                      <span class="arrow-box">
                        &#9662; <!-- sageata jos -->
                      </span>
                      <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                        <el-dropdown-item @click.native="editBonTransfer(scope.row)">
                          {{$t('general.edit')}}
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="download(scope.row)">
                          {{$t('invoice.download')}}
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="downloadExcel(scope.row)">
                          {{$t('gestiune.downloadExcel')}}
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="handleDeleteBonTransfer(scope.row._id)"
                          style="color: red; font-weight: bold;">
                          {{$t('general.delete')}}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-table-column>

              </el-table>
              <el-pagination
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handlePageChange"
                style="margin-top: 15px; text-align: right;"
              ></el-pagination>
          </div>
          </div>
      </div>
    </div>
</template>

  <script>
    // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
    import swal from 'sweetalert2'

    export default {
      // components: {
      //   GeneralTopBar
      // },
      data () {
        return {
          loading: false,
          loadingTimeout: null,
          totalItems: 0,
          currentPage: 1,
          pageSize: 20,
          tableData: [],
          allLocations: [],
          vatNumber: null,
          selectedLocation: null
        }
      },
      props: {
        groupedLocations: {
          type: Array,
          required: true
        },
        gestiuneOptions: {
          type: Array,
          required: true
        }
      },
      created () {
        this.companyID = this.$session.get('selectedCompany')

        this.$bus.$on('refresh', this.handleRefresh)
      },
      // mounted () {
      //   this.$bus.$on('refresh', this.handleRefresh)
      // },
      beforeDestroy () {
        this.$bus.$off('refresh', this.handleRefresh)
      },
      methods: {
        handleRefresh () {
          this.getBons(this.selectedLocation, this.currentPage, this.pageSize)
        },
        onSearch () {
          if (!this.selectedLocation || (Array.isArray(this.selectedLocation) && this.selectedLocation.length === 0)) {
            swal({
              type: 'warning',
              title: this.$t('general.required'),
              text: 'Selectați cel puțin o locație',
              confirmButtonText: 'OK'
            })

            this.tableData = []
            this.totalItems = 0

            return
          }

          // Pregătim array-ul de locații
          const locations = Array.isArray(this.selectedLocation)
            ? this.selectedLocation
            : [this.selectedLocation]

          // Apelăm fetch-ul efectiv
          this.getBons(locations)
        },
        handlePageChange (page) {
          this.currentPage = page
          this.getBons(this.selectedLocation, this.currentPage, this.pageSize)
        },
        getGestiuneNameById (id) {
          const gest = this.gestiuneOptions.find(g => g._id === id || g.id === id)
          return gest ? gest.name : id
        },
        addBonTransfer () {
          this.$router.push('/management/transfer/add')
        },
        editBonTransfer (row) {
          this.$router.push(`/management/transfer/edit/${row.series}/${row.documentNumber}`)
        },
        async getBons (location = null, page = 1, pageSize = 25) {
          try {
            this.loading = true

            const params = new URLSearchParams({
              externalCompanyId: this.companyID,
              tip: 'bon_transfer'
            })

            params.append('page', page)
            params.append('limit', pageSize)

            if (location) {
              if (Array.isArray(location)) {
                const ids = location.map(l => l.true_id).filter(Boolean)
                ids.forEach(id => params.append('externalLocationId', id)) // trimite ca array
              } else if (location.id && location.true_id) {
                params.append('externalLocationId', location.true_id)
              }
            } else {
              const allLocations = this.groupedLocations.flatMap(group => group.locations)
              const ids = allLocations.map(l => l.true_id).filter(Boolean)
              ids.forEach(id => params.append('externalLocationId', id))
            }

            clearTimeout(this.loadingTimeout)
            this.loadingTimeout = setTimeout(() => {
              this.loading = true
            }, 100)

            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/bons?${params.toString()}`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            })

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`)
            }

            const data = await response.json()

            if (Array.isArray(data.bons)) {
              clearTimeout(this.loadingTimeout)
              this.loading = false

              this.totalItems = data.total || 0
              this.currentPage = data.currentPage || page
              this.pageSize = data.pageSize || pageSize

              this.tableData = data.bons.map(bon => ({
                _id: bon._id,
                documentNumber: bon.documentNumber,
                gestiune_from: bon.gestiune_from,
                gestiune_to: bon.gestiune_to,
                series: bon.series
                // total: bon.total || 'N/A'
              }))
            } else {
              console.error('Nu s-au găsit bonuri valide.')
              this.tableData = []
            }
          } catch (error) {
            clearTimeout(this.loadingTimeout)
            this.loading = false

            console.error('Error fetching bons:', error)
          }
        },
        async handleDeleteBonTransfer (id) {
          if (!id) {
            console.error('Missing Bon Transfer ID for deletion.')
            return
          }

          swal({
            title: 'Ești sigur?',
            text: 'Această acțiune va șterge definitiv bonul de transfer!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Da, șterge!',
            cancelButtonText: 'Anulează'
          }).then(async (result) => {
            if (result) {
              try {
                const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/remove`, {
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    type: 'bon_transfer',
                    id: id,
                    externalCompanyId: this.companyID
                  })
                })

                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

                const data = await response.json()
                console.log('Bon transfer deleted successfully:', data)

                swal({
                  title: 'Succes!',
                  text: 'Bonul de transfer a fost șters cu succes.',
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                })

                this.getBons()
              } catch (error) {
                console.error('Error deleting Bon Transfer:', error)

                swal({
                  title: 'Eroare!',
                  text: 'A apărut o problemă la ștergerea bonului de transfer.',
                  type: 'error',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
            }
          })
        },
        async downloadExcel (row) {
          const type = 'bon_transfer'
          const series = row.series
          const invoiceNumber = row.documentNumber
          const externalCompanyId = this.companyID

          if (!type || !series || !invoiceNumber || !externalCompanyId) {
            alert('Missing type, series, invoice number or company ID.')
            return
          }

          const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/${type}/${series}-${invoiceNumber}/xls?externalCompanyId=${externalCompanyId}`

          try {
            const response = await fetch(url)
            if (response.ok) {
              const blob = await response.blob()
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = `${type}-${series}-${invoiceNumber}.xls`
              link.click()
              URL.revokeObjectURL(link.href)
            } else {
              console.error('Error downloading document:', response.statusText)
            }
          } catch (error) {
            console.error('Error fetching document:', error)
          }
        },
        async download (row) {
          const type = 'bon_transfer'
          const series = row.series
          const invoiceNumber = row.documentNumber
          const externalCompanyId = this.companyID

          if (!type || !series || !invoiceNumber || !externalCompanyId) {
            alert('Missing type, series, invoice number or company ID.')
            return
          }

          const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/${type}/${series}-${invoiceNumber}/pdf?externalCompanyId=${externalCompanyId}`

          try {
            const response = await fetch(url)
            if (response.ok) {
              const blob = await response.blob()
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = `${type}-${series}-${invoiceNumber}.pdf`
              link.click()
              URL.revokeObjectURL(link.href)
            } else {
              console.error('Error downloading document:', response.statusText)
            }
          } catch (error) {
            console.error('Error fetching document:', error)
          }
        }
      }
    }
  </script>

<style scoped>
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}

.left-button {
  display: flex;
  gap: 10px;
  align-items: center;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.editareMultipla .vm--modal,
.bonConsumModal .vm--modal{
    background-color: #F4F6FF;
    border-radius: 10px;
}
.checkbox-group {
    display: flex;
    flex-direction: column; /* Aranjează checkbox-urile pe verticală */
}
.el-pagination {
  text-align: center !important;
}
.checkbox-item {
    margin-bottom: 10px; /* Adaugă un spațiu între checkbox-uri */
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.downl {
  background: green !important;
  max-width: fit-content !important;
}
a.delete {
    height: 46px;
    line-height: 26px;
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 160px;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Transfer/ManagementTransfer.vue